import { useRef } from 'react';

import { Icons } from '@/assets/icons/icons';
import { XStack } from '@/components/ui/layout/layout';
import { cn } from '@/lib/utils';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  'aria-label': string;
  className?: string;
  autoFocus?: boolean;
}

export const SearchInput = ({
  value,
  onChange,
  placeholder,
  'aria-label': ariaLabel,
  className,
  autoFocus,
}: SearchInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const clearSearch = () => {
    onChange('');
    inputRef.current?.focus();
  };

  return (
    <XStack
      className={cn(
        'relative flex-1 items-center gap-2 rounded-lg border border-border bg-surface py-1 pl-3 pr-1',
        'transition-colors focus-within:border-accent',
        className
      )}
    >
      <Icons.search
        aria-hidden="true"
        className="size-3.5 shrink-0 text-foreground-muted"
      />
      <input
        ref={inputRef}
        autoFocus={autoFocus}
        type="text"
        aria-label={ariaLabel}
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="w-full bg-transparent py-1 pr-8 text-sm outline-none placeholder:text-foreground-muted"
      />
      {value && (
        <button
          type="button"
          onClick={clearSearch}
          aria-label="Clear search"
          className="absolute right-2 inline-flex size-6 shrink-0 items-center justify-center rounded-md text-foreground-muted hover:bg-secondary-hover hover:text-foreground"
        >
          <Icons.cancel className="size-3.5" />
        </button>
      )}
    </XStack>
  );
};
